// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CloseButton_Wrapper__17Cki","Button":"CloseButton_Button__l0mHt","Line":"CloseButton_Line__3OwD3"};